import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { CdkMenuModule } from "@angular/cdk/menu";

import { SharedModule } from "@shared/shared.module";
import { CalendarActionsComponent } from "./calendar-actions.component";
import { CalendarErrorSidePanelComponent } from "src/app/standalone/calendar-error-side-panel/calendar-error-side-panel.component";

@NgModule({
	declarations: [CalendarActionsComponent],
	exports: [CalendarActionsComponent],
	imports: [CommonModule, MatButtonModule, SharedModule, CdkMenuModule, CalendarErrorSidePanelComponent]
})
export class CalendarActionsModule {}
